import React, { useEffect, useState } from "react";

function Background({ game }: { game: string }) {
  const opacities = Array.from({ length: 6 }, (_, i) => i * 0.2);

  function shuffleArray<T>(array: T[]): T[] {
    const newArr = [...array];
    for (let i = newArr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
  }

  const [numCols, setNumCols] = useState(0);

  useEffect(() => {
    function updateCols() {
      const columnWidth = 60 + 40;
      const cols = Math.ceil(window.innerWidth / columnWidth);
      setNumCols(cols);
    }

    updateCols();
    window.addEventListener("resize", updateCols);

    return () => window.removeEventListener("resize", updateCols);
  }, []);

  return (
    <div className={`columns-container ${game}`}>
      {[...Array(numCols)].map((_, colIndex) => {
        const shuffledOpacities = shuffleArray(opacities);
        return (
          <div className="column" key={colIndex}>
            {shuffledOpacities.map((opacity, rowIndex) => (
              <div
                className={`circle ${game}`}
                style={{ opacity }}
                key={rowIndex}
              ></div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

export default Background;

